<template>
  <div class="rehab-layout">
    <div class="rehab-layout__content">
      <keep-alive>
        <router-view/>
      </keep-alive>
    </div>
    <div v-if="rehabMerchantConfig.logo" class="rehab-layout__brand-strip">
      <img :src="rehabMerchantConfig.logo" :alt="rehabMerchantConfig.name" class="rehab-layout__brand-logo">
      <span>{{ rehabMerchantConfig.name }}</span>
    </div>
    <van-tabbar v-model="active" fixed route safe-area-inset-bottom placeholder :z-index="5000" :active-color="rehabMerchantConfig.themeColor" inactive-color="#666" @change="onChange">
      <van-tabbar-item icon="home-o" :to="{ name: 'RehabCoursesHome' }" name="RehabCoursesHome">课程中心</van-tabbar-item>
      <van-tabbar-item icon="orders-o" :to="{ name: 'RehabCoursesMy' }" name="RehabCoursesMy">我的课程</van-tabbar-item>
      <van-tabbar-item icon="contact-o" :to="{ name: 'RehabCoursesPerson' }" name="RehabCoursesPerson">个人中心</van-tabbar-item>
    </van-tabbar>
  </div>

</template>

<script>
import rehabMerchantMixin from './rehabMerchantMixin'

export default {
  name: 'RehabCoursesTabbar',
  mixins: [rehabMerchantMixin],
  data () {
    return {
      active: 'RehabCoursesHome'
    }
  },
  created () {
    this.initRehabMerchantFromRoute()
    this.applyRehabMerchantTheme()
    this.syncActiveWithRoute()
  },
  watch: {
    '$route.path' () {
      this.syncActiveWithRoute()
    }
  },
  methods: {
    onChange () {},
    syncActiveWithRoute () {
      if (this.$route.name === 'RehabCoursesPerson' || this.$route.path.startsWith('/rehab-courses/person')) {
        this.active = 'RehabCoursesPerson'
      } else if (this.$route.name === 'RehabCoursesMy' || this.$route.path.startsWith('/rehab-courses/my')) {
        this.active = 'RehabCoursesMy'
      } else {
        this.active = 'RehabCoursesHome'
      }
    }
  }
}
</script>

<style scoped>
.rehab-layout { position: fixed; left: 0; right: 0; top: 0; bottom: 0; display: flex; flex-direction: column; background: var(--rehab-theme-color-light, #f7f8fa); }
.rehab-layout__content { flex: 1; box-sizing: border-box; overflow-y: auto; -webkit-overflow-scrolling: touch; }
.rehab-layout__brand-strip {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 8px 12px;
  font-size: 12px;
  color: var(--rehab-theme-color-dark, #06a84e);
  background: rgba(255, 255, 255, 0.92);
  border-top: 1px solid rgba(0, 0, 0, 0.04);
}
.rehab-layout__brand-logo {
  width: 20px;
  height: 20px;
  object-fit: contain;
  border-radius: 6px;
}
</style>
